import { render, staticRenderFns } from "./VolumeLogs.vue?vue&type=template&id=4ce3b139&scoped=true"
import script from "./VolumeLogs.vue?vue&type=script&lang=js"
export * from "./VolumeLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce3b139",
  null
  
)

export default component.exports